import { render } from "./FactoryAnalytics.vue?vue&type=template&id=ba646cf8"
import script from "./FactoryAnalytics.vue?vue&type=script&lang=js"
export * from "./FactoryAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__